export const NOTIFICATIONS = [];

export const STAGES = {
  Initial: 1,
  Unsubscribed: 2,
  Resubscribed: 3,
};

export const STAGES_MAP = {
  1: "Initial",
  2: "Unsubscribed",
  3: "Resubscribed",
};
